import { Component, Input, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-year-to-date-dt',
  templateUrl: './year-to-date-dt.component.html',
  styleUrls: ['./year-to-date-dt.component.scss', '../../../dashboard.scss'],
  standalone: false
})
export class YearToDateDtComponent {
 @Input() dashboardData: any;
  ytdSales: any = 0;
  ytdOrdersItems: string = '';
  ytdSalesValuePerItem: string = '0';
  ytdAverageOrder: string = '0';
  ytdSushiSales: any = 0;
  ytdSushiItemsSold: any = 0;
  ytdBentoSales: any = 0;
  ytdBentoItemsSold: any = 0;
  ytdCommonSales: any = 0;
  ytdCommonItemsSold: any = 0;

  ngOnChanges(changes: SimpleChanges) {
    if (changes['dashboardData']) {
      const dashBoardData = this.dashboardData?.dt_dashboard_data;
      // YTD SALES
      let ytdSales = this.fnCheckNull(dashBoardData?.ytd_sales - dashBoardData?.sales_today);
      ytdSales = this.setDecimalPoints(ytdSales);
      this.ytdSales = ytdSales;

      // YTD ITEM SOLD
      let ytdItemsSold = this.fnCheckNull(dashBoardData?.ytd_items_sold - dashBoardData?.today_items_sold);
      ytdItemsSold = this.setDecimalPoints(ytdItemsSold, 0);

      let ytdNoOfCustOrders = this.fnCheckNull((dashBoardData?.ytd_no_of_cust_orders ?? 0) - (dashBoardData?.today_no_of_cust_orders ?? 0));
      ytdNoOfCustOrders = this.setDecimalPoints(ytdNoOfCustOrders, 0);

      this.ytdOrdersItems = `${ytdNoOfCustOrders.toLocaleString('en-US', { maximumFractionDigits: 0 })} / ${ytdItemsSold.toLocaleString('en-US', { maximumFractionDigits: 0 })}`;

      // SALES VALUE / ITEM
      if (ytdItemsSold > 0) {
        let ytdSalesValueByItem = ytdSales / ytdItemsSold;
        ytdSalesValueByItem = this.setDecimalPoints(ytdSalesValueByItem, 2);
        this.ytdSalesValuePerItem = ytdSalesValueByItem.toFixed(2);
      } else {
        this.ytdSalesValuePerItem = '0';
      }

      // AVERAGE ORDER $
      if (ytdNoOfCustOrders > 0) {
        let ytdAverageOrder = ytdSales / ytdNoOfCustOrders;
        ytdAverageOrder = this.setDecimalPoints(ytdAverageOrder, 2);
        this.ytdAverageOrder = ytdAverageOrder.toFixed(2);
      } else {
        this.ytdAverageOrder = '0';
      }

      // SUSHI SALES
      let ytdSushiSales = this.fnCheckNull((dashBoardData?.ytd_dt_sushi_sales ?? 0) - (dashBoardData?.today_dt_sushi_sales ?? 0));
      ytdSushiSales = this.setDecimalPoints(ytdSushiSales);
      this.ytdSushiSales = ytdSushiSales;

      // SUSHI ITEM SOLD
      let ytdSushiItemsSold = this.fnCheckNull((dashBoardData?.ytd_dt_sushi_items_sold ?? 0) - (dashBoardData?.today_dt_sushi_items_sold ?? 0));
      ytdSushiItemsSold = this.setDecimalPoints(ytdSushiItemsSold, 0);
      this.ytdSushiItemsSold = ytdSushiItemsSold;

      // BENTO SALES
      let ytdBentoSales = this.fnCheckNull((dashBoardData?.ytd_dt_bento_sales ?? 0) - (dashBoardData?.today_dt_bento_sales ?? 0));
      ytdBentoSales = this.setDecimalPoints(ytdBentoSales);
      this.ytdBentoSales = ytdBentoSales;

      // BENTO ITEM SOLD
      let ytdBentoItemsSold = this.fnCheckNull((dashBoardData?.ytd_dt_bento_items_sold ?? 0) - (dashBoardData?.today_dt_bento_items_sold ?? 0));
      ytdBentoItemsSold = this.setDecimalPoints(ytdBentoItemsSold, 0);
      this.ytdBentoItemsSold = ytdBentoItemsSold;

      // COMMON SALES
      let ytdCommonSales = this.fnCheckNull((dashBoardData?.ytd_dt_common_sales ?? 0) - (dashBoardData?.today_dt_common_sales ?? 0));
      ytdCommonSales = this.setDecimalPoints(ytdCommonSales);
      this.ytdCommonSales = ytdCommonSales;

      // COMMON ITEM SOLD
      let ytdCommonItemsSold = this.fnCheckNull((dashBoardData?.ytd_dt_common_items_sold ?? 0) - (dashBoardData?.today_dt_common_items_sold ?? 0));
      ytdCommonItemsSold = this.setDecimalPoints(ytdCommonItemsSold, 0);
      this.ytdCommonItemsSold = ytdCommonItemsSold;
    }
  }

  ngOnInit() {}

  setDecimalPoints(value: number, decimal: number = 1): number {
    return Number(Number(value).toFixed(decimal));
  }
  fnCheckNull(a: any): number {
    return a == null ? 0 : a;
  }
}
